import { Asset } from "@/types/assets";

import axiosInstance from "../config";

export const getAsset = async (assetId: string): Promise<Asset> => {
  const { data } = await axiosInstance.get(`/v1/assets/${assetId}`);
  return data;
};
